import styled from 'styled-components'
import * as BaseStyles from '../BaseStyles'

import collapseIcon from '../../Icons/Normal/Subsections/collapse-icon.png'
import expandIcon from '../../Icons/Normal/Subsections/expand-icon.png'

export const DisclaimerContainerDiv = styled(BaseStyles.Div)`
    padding: 1.2rem 2rem;
`

export const DisclaimerContainerContentsDiv = styled(BaseStyles.Div)`
    margin: 0rem auto;
    min-width: 20rem;
    max-width: 140rem;      
`

export const DisclaimerContentsDiv = styled(BaseStyles.Div)`
    box-shadow:
    0 0px 2px rgba(0, 0, 0, 0.022),
    0 0px 3px rgba(0, 0, 0, 0.031),
    0 0px 4px rgba(0, 0, 0, 0.039),
    0 0px 5px rgba(0, 0, 0, 0.048),
    0 0px 6px rgba(0, 0, 0, 0.07)
    ;   
    background-color: #ff4d4d;
    border-radius: 1.5rem;
    padding: 1.2rem;
`

export const DisclaimerHeaderContainer = styled(BaseStyles.Div)`
    width: 100%;
    overflow: hidden;
`

export const DisclaimerSectionHeader = styled(BaseStyles.SectionHeader)`
    color: black;
    padding: 0;
    font-size: 1.7rem;
    float: left;
`

export const CollapseButton = styled(BaseStyles.IconButton)`
    background-image: url(${collapseIcon});
    width: 1.7rem;
    height: 1.7rem;
    float: right;
    cursor: pointer;
`

export const ExpandButton = styled(BaseStyles.IconButton)`
    background-image: url(${expandIcon});
    width: 1.7rem;
    height: 1.7rem;
    float: right;
    cursor: pointer;
`

export const DisclaimerDescription = styled(BaseStyles.Description)`
    padding-top: 1rem;
    font-size: 1.4rem;
    color: black;
`
